// easyui-accordion.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-accordion',
  template:  `
    <div style="height: 100%">
      <div #host>
        <ng-content></ng-content>
      </div>
    </div>
  `
})

export class EasyuiAccordionComponent implements AfterViewInit {
  private host: any;
  @Input('options') options: any = {};
  @ViewChild('host') hostElement: ElementRef;

  constructor() {
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // evento chiamato alla fine dell'inizializzazione della view
  ngAfterViewInit() {
    this.configura(this.options);
  }

  // compila il componente nativo easyui
  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    const localoptions = {
      fit: true
    };
    Object.assign(localoptions, options);
    this.host.accordion(localoptions);
    // let panelTitle = this.host.find('.panel-title')
    // let panelHeader = this.host.find('.panel-header')
    // panelTitle.css({'border': '2px solid red', 'transform': 'rotate(90deg)'})
    // panelHeader.css({ 'height': 300, 'width': 40})
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-accordion.component.ts